var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawOnlineSurveyXq2G(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 740.981,
    height: 767.246,
    viewBox: "0 0 740.981 767.246",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-440.646 -84.879)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(691.645 336.975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.805,145.7h81.007a12.363,12.363,0,0,0,12.346-12.346V52.346A12.363,12.363,0,0,0,573.812,40H492.805a12.363,12.363,0,0,0-12.346,12.346v81.009A12.363,12.363,0,0,0,492.805,145.7ZM573.812,41.975a10.372,10.372,0,0,1,10.372,10.371v81.009a10.372,10.372,0,0,1-10.372,10.372H517.069a34.636,34.636,0,0,1-34.636-34.636V52.346a10.372,10.372,0,0,1,10.372-10.372Z",
    transform: "translate(-480.459 -0.485)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.805,145.7h81.007a12.363,12.363,0,0,0,12.346-12.346V52.346A12.363,12.363,0,0,0,573.812,40H492.805a12.363,12.363,0,0,0-12.346,12.346v81.009A12.363,12.363,0,0,0,492.805,145.7Z",
    transform: "translate(-480.459 -0.485)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.867,
    cy: 10.867,
    rx: 10.867,
    ry: 10.867,
    transform: "translate(42.477 0)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(829.494 213.059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M385.333,307.418H466.34a12.363,12.363,0,0,0,12.346-12.346V214.063a12.363,12.363,0,0,0-12.346-12.346H385.333a12.363,12.363,0,0,0-12.346,12.346V295.07A12.363,12.363,0,0,0,385.333,307.418ZM466.34,203.69a10.372,10.372,0,0,1,10.372,10.372v81.007a10.372,10.372,0,0,1-10.372,10.372h0a91.379,91.379,0,0,1-91.38-91.379h0a10.372,10.372,0,0,1,10.372-10.372h81.006Z",
    transform: "translate(-372.987 -162.198)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.867,
    cy: 10.867,
    rx: 10.867,
    ry: 10.867,
    transform: "translate(42.477 0)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.142,249.489a6.655,6.655,0,1,1,4.826-5.421c-.417,2.514-1.968,4.7-3.377,6.757-1.57,2.291-3.212,4.532-4.9,6.734-3.827,4.981-7.912,9.76-11.986,14.538a1.5,1.5,0,0,0,1.048,2.529l23.18,2.121c1.9.174,1.887-2.791,0-2.964l-23.18-2.121,1.048,2.529c4.489-5.266,8.972-10.541,13.151-16.058a97.31,97.31,0,0,0,5.737-8.152c1.513-2.493,2.66-5.339,2.224-8.3-.751-5.109-5.832-9.212-11.011-8.467a10.191,10.191,0,0,0-8.373,11.152c.814,5.648,6.986,9.419,12.405,7.978a1.483,1.483,0,0,0-.787-2.858h0Z",
    transform: "translate(-373.474 -162.577)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(717.295 84.879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M572.805,407.7h81.006a12.363,12.363,0,0,0,12.346-12.346V314.346A12.363,12.363,0,0,0,653.812,302H572.805a12.363,12.363,0,0,0-12.346,12.346v81.009A12.363,12.363,0,0,0,572.805,407.7Zm81.006-103.728a10.373,10.373,0,0,1,10.372,10.371v81.009a10.372,10.372,0,0,1-10.372,10.372h0a91.379,91.379,0,0,1-91.38-91.383h0A10.372,10.372,0,0,1,572.8,303.974Z",
    transform: "translate(-560.459 -262.485)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.867,
    cy: 10.867,
    rx: 10.867,
    ry: 10.867,
    transform: "translate(42.476 0)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.82,337.913c5.07-2.578,11.815-.692,13.668,5a7.609,7.609,0,0,1-7.92,10.189v2.964a13.525,13.525,0,0,1,8.974,3.849,9.135,9.135,0,0,1,2.331,8.58,7.279,7.279,0,0,1-13.741.667c-.7-1.746-3.573-.983-2.858.787a10.332,10.332,0,0,0,15.747,4.65c5.641-4.237,5.068-12.575.2-17.19a16.9,16.9,0,0,0-10.655-4.3c-1.919-.124-1.868,2.777,0,2.964a10.493,10.493,0,0,0,9.159-4.13,10.64,10.64,0,0,0,1.618-9.811c-2.455-7.575-11.211-10.231-18.019-6.768-1.7.865-.2,3.42,1.5,2.559h0Z",
    transform: "translate(-560.971 -262.873)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-89.424 -88)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.765,
    height: 602.949,
    transform: "matrix(-0.99, -0.141, 0.141, -0.99, 1123.775, 800.49)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 239.934,
    height: 8.613,
    transform: "translate(1031.117 931.512)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,367.87l71.218,286.1,8.318-2.215L136.018,365.67Z",
    transform: "translate(1026.682 285.734)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.304,
    cy: 12.304,
    r: 12.304,
    transform: "translate(1141.857 641.129)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440.646 349.416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M770.517,302.971s14.822-2.556,36.8-22.489c17.389-15.766,40.844-12.666,49.888-10.678a1.544,1.544,0,0,1,.411,2.867c-3.656,2-9.322,4.922-11.978,5.255,0,0,5.478,5.667-.344,8.7a4.189,4.189,0,0,1-4.378-.422c-2.8-2.044-10.578,2.6-21.855,5.011,0,0-43.955,45.488-54.177,37.777Z",
    transform: "translate(-607.425 -177.174)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.865,246.027s-4.089,17.377,0,29.644l-18.4,2.556-16.355-8.178V259.316s7.667-16.355,5.622-35.266Z",
    transform: "translate(-859.45 -182.074)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.316,585.888s-13.333,26.066-11.244,43.444-17.378,2.044-15.333-8.178c.433,12.374-5.722-43.333-8.6-56.377a5.822,5.822,0,0,1,3.866-6.789c6.145-2.022,16.433-4.5,21.6-.711C992.238,562.888,994.316,585.888,994.316,585.888Z",
    transform: "translate(-959 -145.273)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.513,608.743s17.378,22.488,21.978,23,7.667,7.667,0,9.2a85.931,85.931,0,0,1-45.555-4.444,6.956,6.956,0,0,1-4.367-7.4L892.5,607.21Z",
    transform: "translate(-831.632 -139.507)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.381,393.78,986.047,396a243.915,243.915,0,0,0,.2,58.588v70s.322,6.167-12.478,15.133a478.535,478.535,0,0,0-38.755,30L888.637,609.9s-18.4-22.489-15.844-35.777c0,0,30.666-9.711,34.755-25.555,2.344-9.067,14.233-16.666,23.966-21.444A29.8,29.8,0,0,0,947.459,493.3a26.08,26.08,0,0,0-2.611-6.567c-8.178-14.311-19.933-46.51-19.933-46.51L947.4,397.358Z",
    transform: "translate(-854.877 -163.218)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.245,634s-30.155,5.111-31.178,8.178,0-4.089,0-4.089-17.378-52.644-13.333-99.143-5.111-77.177-5.111-77.177-10.733-34.755-4.6-54.688,70.533-11.244,70.533-11.244-22.489,52.644-21.978,77.688c0,0-2.555,75.643-7.155,84.332C938.467,557.814,945.622,631.924,951.245,634Z",
    transform: "translate(-861.276 -163.198)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.83,255.79s-3.067,18.889-33.733,10.733l20.4,155.364s59.288,2.044,58.777-5.111l-12.222-94.032Z",
    transform: "translate(-819.404 -178.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.2,255.33a31.633,31.633,0,0,0,15.789,6.5,35.921,35.921,0,0,1,14.511,4.311c5.255,2.944,11.111,7.222,12.889,12.433,3.578,10.222,26.066,27.088,36.288,23.511L918.1,332.751s-29.133-1.533-34.244-12.778l8.678,109.432h-7.667s-4.089-29.644-7.156-35.777-9.2-39.866-9.711-48.044-8.178-55.2-14.822-63.332L842.19,258.485Z",
    transform: "translate(-756.576 -178.599)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.388,238.974c.667-4.844-.667-7.867-1.278-13.544l29.133,21.977s-.7,2.967-1.233,7.311a27.78,27.78,0,0,1-4.444.356C925.454,255.074,918.177,247.174,913.388,238.974Z",
    transform: "translate(-853.828 -181.92)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.6,
    cy: 27.6,
    rx: 27.6,
    ry: 27.6,
    transform: "translate(54.192 16.432)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.173,201.6a32.24,32.24,0,0,0-2.051-12.6,3.148,3.148,0,0,1-.533,4.1,20.184,20.184,0,0,0-6.4-11.342c1.815.3,2.748,2.543,2.3,4.328a9.844,9.844,0,0,1-3.148,4.43c.154-2.7-1.631-5.22-3.887-6.7a23.32,23.32,0,0,0-7.589-2.748,4.4,4.4,0,0,1,2.913,4.512,1.261,1.261,0,0,1-.379.872,1.446,1.446,0,0,1-.862.226,66.028,66.028,0,0,1-7.968-.174,83.565,83.565,0,0,0-9.814-.523c-10.255.431-20.562,7.435-22.859,17.434a40.077,40.077,0,0,0-.749,7.363l-.5,12.624a46.147,46.147,0,0,0,.451,11.034A23.382,23.382,0,0,0,903.1,250.313c3.7-5.363,4.03-12.255,5.312-18.644a9.435,9.435,0,0,1,1.6-4.1,3.6,3.6,0,0,1,3.948-1.333c1.385.554,1.979,2.666.831,3.61,1.026,1.21,2.943.308,4.1-.769a22.028,22.028,0,0,0,6.389-11.414c.461-2.195.923-4.9,3.077-5.651a5.722,5.722,0,0,1,2.277-.154c4.492.308,11.517,2.164,15.865.738C950.491,211.282,952.173,205.385,952.173,201.6Z",
    transform: "translate(-842.641 -181.07)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.02,251l-32.966,28.366S903.632,299.3,911.81,331.5c0,0,3.578,47.022,7.667,49.066,0,0,14.311,28.622,15.333,55.71,0,0,20.189-40.633,28.889-17.122s27.855,28.888,27.855,28.888L980.309,309.032S951.931,259.644,956.02,251Z",
    transform: "translate(-901.573 -179.08)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.806,358.931s-8.178-5.622-21.466,9.711l32.711,59.288,10.989-16.589S955.784,365.575,956.806,358.931Z",
    transform: "translate(-917.435 -167.201)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.874,304.78s-1.022,36.8,3.067,50.6",
    transform: "translate(-903.137 -173.105)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.133,311.935S876,309.891,876,304.78",
    transform: "translate(-754.596 -173.105)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.069,311.743l6.9-4.454c-2.832,5.382-5.273,13.788-6.579,20.477-2.212-6.231-5.778-13.855-9.308-18.409l7.3,2.557c-4.5-30.012-21.411-51.558-40.78-51.558v-2.285C190.837,258.071,208.478,280.519,213.069,311.743Z",
    transform: "matrix(-0.407, 0.914, -0.914, -0.407, 1307.025, 387.041)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.462,16.023l6.905,4.454C46.535,15.1,44.094,6.689,42.788,0,40.576,6.231,37.01,13.855,33.48,18.409l7.3-2.557C36.28,45.865,19.369,67.411,0,67.411V69.7C20.23,69.7,37.871,47.248,42.462,16.023Z",
    transform: "matrix(0.259, -0.966, 0.966, 0.259, 957.896, 227.883)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.069,311.743l6.9-4.454c-2.832,5.382-5.273,13.788-6.579,20.477-2.212-6.231-5.778-13.855-9.308-18.409l7.3,2.557c-4.5-30.012-21.411-51.558-40.78-51.558v-2.285C190.837,258.071,208.478,280.519,213.069,311.743Z",
    transform: "matrix(-0.407, 0.914, -0.914, -0.407, 1348.9, 266.041)",
    fill: "#d6d6e3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawOnlineSurveyXq2G);
export default __webpack_public_path__ + "static/media/undraw_online-survey_xq2g.da0f76ea83e815761634d9dc23093a0d.svg";
export { ForwardRef as ReactComponent };